<template>
	<tr
		:class="[
			'TableRow',
			getStatusClass(lead.status),
			isExpanded && 'expanded',
		]"
	>
		<td>{{ lead.name }}</td>
		<td class="TableRow_dateCell">{{ formatDate(lead.date) }}</td>
		<td class="TableRow_statusCell">
			<select
				class="TableRow_statusSelect status-color"
				v-model="lead.status"
				@change.stop="() => handleChange()"
			>
				<option
					v-for="(option, key) in statusOptions"
					:value="option"
					:disabled="disableOption(option)"
					:key="key"
				>
					{{ option }}
				</option>
			</select>
		</td>
		<td :class="['TableRow_formCell', revFocused && 'focus']">
			<div class="TableRow_formCell-entry d-flex align-start gap-10">
				<label class="flex-grow-1" for="">Guest Rooms</label>
				<RevenueInputCur v-model="lead.rooms" />
			</div>
			<div class="TableRow_formCell-entry d-flex align-start gap-10">
				<label class="flex-grow-1" for="">Banquet</label>
				<RevenueInputCur v-model="lead.banquet" />
			</div>
			<div class="d-flex align-center gap-10">
				<strong class="formTotal-label">Total Revenue</strong>
				<strong class="formTotal-value">{{
					leadRevenue | currency
				}}</strong>
			</div>
		</td>
		<td class="TableRow_controls">
			<v-btn
				:disabled="ctaDisabled"
				:color="ctaColor"
				type="button"
				@click="saveLead"
				small
				>{{ ctaLabel }}</v-btn
			>
			<button class="link" type="button" @click="handleExpand">
				<span v-if="!isExpanded"> +View Detail </span>
				<span v-else> -Close Detail </span>
			</button>
		</td>
	</tr>
</template>

<script>
import dayjs from "dayjs";
import { LEAD_STATUSES, BUS_EVENTS } from "@/constants";
import RevenueInputCur from "@/components/RevenueInputCur";
import { EventBus } from "@/utilities";
import { mapActions } from "vuex";

export default {
	name: "TableRow",
	components: {
		RevenueInputCur,
	},
	props: {
		item: Object,
		expand: Function,
		isExpanded: Boolean,
	},
	data() {
		return {
			lead: {
				rooms: null,
				banquet: null,
				status: LEAD_STATUSES.NEW,
			},
			leadPrevStatus: LEAD_STATUSES.NEW,
			statusOptions: LEAD_STATUSES,
			revFocused: false,
			ctaLabel: "Saved",
			ctaColor: "primary",
			ctaDisabled: true,
		};
	},
	beforeMount() {
		this.lead = JSON.parse(JSON.stringify(this.item)); //object deep copy
		this.leadPrevStatus = this.lead.status;

		EventBus.$on(BUS_EVENTS.LEAD_DOWN_SAVED, this.updateCTA);
		EventBus.$on(BUS_EVENTS.LEAD_DOWN_CANCELED, this.resetStatus);

		EventBus.$on(BUS_EVENTS.LEAD_LOST_SAVED, this.updateCTA);
		EventBus.$on(BUS_EVENTS.LEAD_LOST_CANCELED, this.resetStatus);
	},
	computed: {
		leadRevenue() {
			return Number(this.lead.rooms) + Number(this.lead.banquet);
		},
	},
	methods: {
		...mapActions(["saveExtraLeads", "getleadById"]),
		disableOption(option) {
			// return option === LEAD_STATUSES.NEW;
			return false;
		},
		formatDate(date = "") {
			return dayjs(date).format("MM/DD/YY");
		},

		getStatusClass(status) {
			const statusKey = Object.keys(LEAD_STATUSES).find(
				(key) => LEAD_STATUSES[key] === status
			);
			return `status-${statusKey ? statusKey.toLowerCase() : ''}`;
		},

		getLeadTotalrevenue(revenue = []) {
			const total = revenue.reduce((prevTotal, entry) => {
				return Number(prevTotal) + Number(entry.value);
			}, 0);

			return total ? total : 0;
		},

		handleChange() {
			this.revFocused = true;
			if (this.lead.status === LEAD_STATUSES.DOWN) {
				EventBus.$emit(BUS_EVENTS.LEAD_DOWN, this.lead);
			}

			if (this.lead.status === LEAD_STATUSES.LOST) {
				EventBus.$emit(BUS_EVENTS.LEAD_LOST, this.lead);
			}
		},

		viewDetail(item) {
			console.log(item);
			alert("Showing Lead Details...");
		},

		updateCTA(leadChanged = false) {
			this.ctaDisabled = !leadChanged;
			this.ctaLabel = leadChanged ? "Update" : "Saved";
			this.ctaColor = leadChanged ? "success" : "primary";
		},

		resetStatus() {
			this.lead.status = this.leadPrevStatus;
		},

		async saveLead() {
			console.log(this.lead.id, "SAVE");

			/* if (this.lead.status == "New") {
				EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED, {
					type: "warning",
					message: "Please change lead status",
					duration: 2e3,
				});
				return false;
			} */

			const statusAllow = ["Tentative", "Definite"];

			if (statusAllow.includes(this.lead.status)) {
				if (
					(this.lead.rooms == 0 || this.lead.rooms.length == 0) &&
					(this.lead.banquet == 0 || this.lead.banquet.length == 0)
				) {
					EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED, {
						type: "warning",
						message: "All lead fields are required",
						duration: 2e3,
					});
					return false;
				}
			}

			const extrafields = new FormData();
			extrafields.append("lead_id", this.lead.id);
			if (this.lead.lead_extra_id !== undefined)
				extrafields.append("id", this.lead.lead_extra_id);
			extrafields.append("status", this.lead.status);
			extrafields.append("rooms", this.lead.rooms);
			extrafields.append("banquet", this.lead.banquet);
			extrafields.append("save_history", true);

			try {
				const lead_extra_id = await this.saveExtraLeads(extrafields);

				if (this.lead.lead_extra_id == undefined)
					this.lead.lead_extra_id = lead_extra_id;

				EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED, {
					type: "success",
					message: "Lead Saved Successfully",
					duration: 2e3,
				});
				EventBus.$emit(BUS_EVENTS.STATS_UPDATED);

				this.updateCTA(false);
				this.revFocused = false;
			} catch (error) {
				EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED, {
					type: "error",
					message: "Lead cannot be saved. Please try again later.",
					duration: 2e3,
				});
				console.error(err.response.status);
			}
		},

		async handleExpand() {
			this.expand(!this.isExpanded);
			if (!this.isExpanded) {
				EventBus.$emit(BUS_EVENTS.LEAD_UNEXPANDED);
			}
		},
	},
	filters: {
		currency(value) {
			return new Intl.NumberFormat("en", {
				style: "currency",
				currency: "USD",
				maximumFractionDigits: 2,
			})
				.format(value)
				.replace(".00", "");
		},
	},
	watch: {
		lead: {
			handler(value, oldValue) {
				const leadChanged =
					JSON.stringify(value) !== JSON.stringify(this.item);
				this.updateCTA(leadChanged);

				this.leadPrevStatus = this.item.status;
			},
			deep: true,
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/scss/colors.scss";
.TableRow {
	position: relative;
	&:hover {
		background: none !important;
	}
	&.expanded {
		background: #efefef !important;
		td {
			border-bottom-color: #efefef !important;
			padding-bottom: 0 !important;
		}
	}
	&_dateCell {
		// width: 130px;
	}
	&_statusCell {
		// width: 160px;
	}
	&_statusSelect {
		font-size: 13px;
		background: #ffffff no-repeat right 10px center;
		display: block;
		width: 110px;
		max-width: 100%;
		height: 22px;
		padding: 0 10px;
		border: 1px solid;
		border-radius: 6px;
	}
	&_formCell {
		width: 320px;
		&-entry {
			margin-bottom: 8px;
		}
		label {
			font-size: 13px;
			min-width: 120px;
		}
		strong {
			color: $purple;
		}

		/deep/ .revenueInput {
			position: relative;
			input,
			.mask {
				font-size: 13px;
				background: #ffffff;
				display: block;
				width: 90px;
				max-width: 100%;
				height: 22px;
				padding: 0 10px;
				border: 1px solid #c3c3c3;
				border-radius: 6px;
				appearance: none;
			}
			input {
				-moz-appearance: textfield;
				appearance: none;
				&::-webkit-outer-spin-button,
				&::-webkit-inner-spin-button {
					-webkit-appearance: none;
					margin: 0;
				}
			}
			.mask {
				position: absolute;
				top: 0;
				z-index: 1;
				pointer-events: none;
			}
			.symbol {
				color: $purple;
				height: 1em;
				margin-top: -0.5em;
				line-height: 1;
				position: absolute;
				top: 50%;
				right: 0.5em;
				z-index: 1;
				pointer-events: none;
			}
		}

		&.focus {
			/deep/ .revenueInput {
				.mask {
					border-color: #fc7e22;
				}
			}
		}

		.formTotal {
			&-label {
				flex: 1 1;
			}
			&-value {
				width: 90px;
			}
		}
	}
	&_controls {
		width: 150px;
		text-align: center;
		position: relative;
		&::before {
			background: #e2e2e2;
			display: block;
			width: 1px;
			height: calc(100% - 40px);
			position: absolute;
			top: 20px;
			left: 0;
			z-index: 1;
			content: "";
		}
	}
	.link {
		font-size: 12px;
		color: $purple;
		display: inline-block;
		margin: 0;
		font-weight: 500;
	}

	&.status {
		&-new {
			.status-color {
				color: $red;
			}
			.TableRow_statusSelect {
				background-image: url("~@/assets/img/arrow-select1-red.svg");
			}
		}
		&-tentative {
			.status-color {
				color: $yellow;
			}
			.TableRow_statusSelect {
				background-image: url("~@/assets/img/arrow-select1-yellow.svg");
			}
		}
		&-definite {
			.status-color {
				color: $green;
			}
			.TableRow_statusSelect {
				background-image: url("~@/assets/img/arrow-select1-green.svg");
			}
		}
		&-prospect {
			.status-color {
				color: $blue;
			}
			.TableRow_statusSelect {
				background-image: url("~@/assets/img/arrow-select1-blue.svg");
			}
		}
		&-lost {
			opacity: 0.4;
			cursor: not-allowed;
			.status-color {
				color: darken($red, 20%);
			}
			.TableRow_statusSelect {
				background-image: url("~@/assets/img/arrow-select1-red.svg");
			}
			> * {
				cursor: inherit;
			}
		}
		&-down {
			opacity: 0.4;
			cursor: not-allowed;
			// pointer-events: none;
			.status-color {
				color: #a0a0a0;
			}
			.TableRow_statusSelect {
				background-image: url("~@/assets/img/arrow-select1-darkgray.svg");
			}
			> * {
				cursor: inherit;
			}
		}
		&-contacted {
			.status-color {
				color: darken($mint, 20%);
			}
			.TableRow_statusSelect {
				background-image: url("~@/assets/img/arrow-select1-mint.svg");
			}
		}
	}
	.v-btn {
		min-width: 90px !important;
		// &.v-btn--disabled{
		//     background: lighten( desaturate($purple, 50%), 20% ) !important;
		//     color: #FFF !important;
		// }
	}
}
</style>



// WEBPACK FOOTER //
// src/components/TableWeddings/TableRow.vue